import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEdxComponent } from './simple-icons-edx.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEdxComponent ],
    exports:      [ SimpleIconsEdxComponent ],
    bootstrap:    []
})
export class SimpleIconsEdxModule {}
